import api from "./axios";

export function getOfflinePosCapability() {
  return api.get("/pos/offline/capability");
}

export function enrollOfflinePosDevice(payload) {
  return api.post("/pos/offline/devices", payload);
}

export function listOfflinePosDevices() {
  return api.get("/pos/offline/devices");
}

export function refreshOfflinePosGrant(devicePublicId, deviceSecret) {
  return api.post(
    `/pos/offline/devices/${encodeURIComponent(devicePublicId)}/grant`,
    undefined,
    { headers: { "X-Offline-POS-Device-Secret": deviceSecret } },
  );
}

export function revokeOfflinePosDevice(devicePublicId) {
  return api.delete(`/pos/offline/devices/${encodeURIComponent(devicePublicId)}`);
}

export function getOfflinePosSnapshot(
  devicePublicId,
  deviceSecret,
  grant,
  options = {},
) {
  return api.get("/pos/offline/snapshot", {
    signal: options.signal,
    headers: {
      "X-Offline-POS-Device-Id": devicePublicId,
      "X-Offline-POS-Device-Secret": deviceSecret,
      "X-Offline-POS-Grant": grant,
    },
  });
}

export function syncOfflinePosSales(
  transactions,
  devicePublicId,
  deviceSecret,
  grant,
  options = {},
) {
  return api.post(
    "/pos/offline/sales/sync",
    { transactions },
    {
      signal: options.signal,
      headers: {
        "X-Offline-POS-Device-Id": devicePublicId,
        "X-Offline-POS-Device-Secret": deviceSecret,
        "X-Offline-POS-Grant": grant,
      },
    },
  );
}
